import axios from '../axios';

function buildTempCodeProvisionHistoryQuery (options = {}) {
  const params = {};
  if (options.page) {
    params.page = options.page;
  }
  const limit = options.limit != null ? options.limit : options.per_page;
  if (limit) {
    params.limit = limit;
  }
  if (options.filters && typeof options.filters === 'object') {
    Object.keys(options.filters).forEach((key) => {
      const v = options.filters[key];
      if (v === '' || v === null || v === undefined) {
        return;
      }
      if (key === 'channel' || key === 'client_id' || key === 'address' || key === 'event' || key === 'doorphone_id') {
        params[key] = v;
      } else {
        params[`filter[${key}]`] = v;
      }
    });
  }
  const query = [];
  for (const param in params) {
    query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
  }
  return query.length ? '?' + query.join('&') : '';
}

export default {
  getDoorphones (options) {
    const params = {};

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/web/doorphone?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getMapDoorphones (options) {
    const params = {};

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/web/map-doorphones?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getMfDoorphones (options) {
    const params = {};

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    if (options.ids_only) {
      params.ids_only = 1;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        const value = options.filters[filterName];
        if (value === null || value === undefined || value === '') {
          continue;
        }
        if (Array.isArray(value)) {
          value.forEach((item, idx) => {
            params[`filter[${filterName}][${idx}]`] = item;
          });
        } else {
          params[`filter[${filterName}]`] = value;
        }
      }
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/web/mf-doorphones?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getOpenDoorSoundWhitelist (options = {}) {
    const params = {};
    if (options.page) params.page = options.page;
    if (options.limit) params.limit = options.limit;
    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        const value = options.filters[filterName];
        if (value === null || value === undefined || value === '') {
          continue;
        }
        params[`filter[${filterName}]`] = value;
      }
    }
    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }
    const qs = query.length ? `?${query.join('&')}` : '';
    return new Promise((resolve, reject) => {
      axios.get(`/open-door-sound-whitelist${qs}`)
        .then(resolve)
        .catch(reject);
    });
  },
  storeOpenDoorSoundWhitelist ({ doorphoneIds, comment }) {
    return new Promise((resolve, reject) => {
      axios.post('/open-door-sound-whitelist', { doorphone_ids: doorphoneIds, comment })
        .then(resolve)
        .catch(reject);
    });
  },
  updateOpenDoorSoundWhitelist (id, { comment }) {
    return new Promise((resolve, reject) => {
      axios.put(`/open-door-sound-whitelist/${id}`, { comment })
        .then(resolve)
        .catch(reject);
    });
  },
  destroyOpenDoorSoundWhitelist (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/open-door-sound-whitelist/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  getMassAudioUploadJobs ({ active } = {}) {
    const params = {};
    if (active) {
      params.active = 1;
    }
    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }
    const qs = query.length ? `?${query.join('&')}` : '';
    return new Promise((resolve, reject) => {
      axios.get(`/mass-audio-upload-jobs${qs}`)
        .then(resolve)
        .catch(reject);
    });
  },
  getMassAudioUploadJob (massUploadId) {
    return new Promise((resolve, reject) => {
      axios.get(`/mass-audio-upload-jobs/${massUploadId}`)
        .then(resolve)
        .catch(reject);
    });
  },
  cancelMassAudioUploadJob (massUploadId) {
    return new Promise((resolve, reject) => {
      axios.post(`/mass-audio-upload-jobs/${massUploadId}/cancel`)
        .then(resolve)
        .catch(reject);
    });
  },
  getMassLcdUploadJobs ({ active } = {}) {
    const params = {};
    if (active) {
      params.active = 1;
    }
    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }
    const qs = query.length ? `?${query.join('&')}` : '';
    return new Promise((resolve, reject) => {
      axios.get(`/mass-lcd-upload-jobs${qs}`)
        .then(resolve)
        .catch(reject);
    });
  },
  getMassLcdUploadJob (massUploadId) {
    return new Promise((resolve, reject) => {
      axios.get(`/mass-lcd-upload-jobs/${massUploadId}`)
        .then(resolve)
        .catch(reject);
    });
  },
  cancelMassLcdUploadJob (massUploadId) {
    return new Promise((resolve, reject) => {
      axios.post(`/mass-lcd-upload-jobs/${massUploadId}/cancel`)
        .then(resolve)
        .catch(reject);
    });
  },
  exportAudioUpload (massUploadId) {
    return new Promise((resolve, reject) => {
      axios.get(`/audio-upload/${massUploadId}/export`, {
        responseType: 'blob',
      })
        .then(resolve)
        .catch(reject);
    });
  },
  downloadAudioUploadFile (massUploadId) {
    return new Promise((resolve, reject) => {
      axios.get(`/audio-upload/${massUploadId}/file`, {
        responseType: 'blob',
      })
        .then(resolve)
        .catch(reject);
    });
  },
  getExpandedDoorphones (options) {
    const params = {
      hidden: 1,
    };

    if (options.pagination) {
      params.pagination = 1;
    }

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    if (options.include && options.include.length) {
      params.include = options.include.join();
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    if (options.append && options.append.length) {
      params.append = options.append.join();
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/doorphone?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getAllSCUD (options) {
    const params = {};

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/doorphone/unified-search?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getDoorphoneVideo: (id) => axios.get(`/doorphone/${id}/camera`),
  getSipHistory: (id) => axios.get(`/doorphone/${id}/sip-status-logs`),
  getSipStatus: (id) => axios.put(`/doorphone/${id}/sip-status`),
  getDoorphone (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/web/doorphone/${id}`)
        .then(({ data }) => {
          resolve(data.doorphone);
        })
        .catch(error => reject(error));
    });
  },
  getExpandedDoorphone (id, options) {
    const params = {};
    if (options.include && options.include.length) {
      params.include = options.include.join();
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}?` + query.join('&'))
        .then(({ data }) => {
          resolve(data.doorphone);
        })
        .catch(error => reject(error));
    });
  },
  newDoorphone (doorphone) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone', doorphone)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  additionalDoorphone (doorphone) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/create-additional-entrance', doorphone)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateDoorphone (id, doorphone) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}`, doorphone)
        .then((response) => {
          if (response.data.errors.length > 0) {
            reject(response.data.errors);
          } else {
            resolve(response);
          }
        })
        .catch(error => reject(error));
    });
  },
  updateCoordsDoorphone (id, doorphone) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/coords`, doorphone)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  deleteDoorphone (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/doorphone/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getRules (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/rules`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  importRules (id) {
    return new Promise((resolve, reject) => {
      axios.post(`rules/doorphone/${id}/import`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateRules (id, rules) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/rules`, { rules })
        .then((response) => {
          resolve(response);
        })
        .catch(error => {
          if (error.data && error.data.error && error.data.errors.length > 0) {
            reject(error.data.errors);
          } else {
            reject(error);
          }
        });
    });
  },
  getSoundSettings (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/sound`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  updateSoundSettings (id, settings) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/sound`, settings)
        .then((response) => {
          const { errors } = response.data;
          if (errors.length > 0) {
            reject(errors);
          } else {
            resolve(response);
          }
        })
        .catch(error => reject(error));
    });
  },
  getTimeSettings (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/datetime`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  updateTimeSettings (id, settings) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/datetime`, settings)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getJournalsip (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/ring-journal`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getJournalSipAllBeward (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/ring-journal-all`, {
        params: {
          sort: 'asc',
        },
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  syncJournalSipExtended (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/ring-journal-extended`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getAddressSearch (value) {
    return new Promise((resolve, reject) => {
      axios.get('/address/search', {
        params: value,
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getCities (address) {
    return new Promise((resolve, reject) => {
      axios.get('/doorphone/address', {
        params: address,
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getStreets (address) {
    return new Promise((resolve, reject) => {
      axios.get('/doorphone/address', {
        params: address,
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getHouses (address) {
    return new Promise((resolve, reject) => {
      axios.get('/doorphone/address', {
        params: address,
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  uploadMassDoorsound (formData) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/wav-open', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  uploadDoorsound (id, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/wav-open`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  uploadErrorSound (id, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/error-sound`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  uploadKeypressSound (id, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/keypress-sound`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  uploadCustomSound (id, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/custom-sound`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  uploadEmergencySound (id, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/emergency-sound`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  uploadKeys (id, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/import-keys`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  uploadMassRingsound (formData, { doorphones }) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/wav-ring', {
        doorphones,
      }, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  uploadOpenDoorSound (formData) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/upload-open-door-sound', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  uploadRingsound (id, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/wav-ring`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  uploadTextmessage (text, id, isEnabled) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/text`, {
        text,
        is_enabled: isEnabled,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  setMassAutoKey (toggle, outputsSet, doorphones) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/mass-auto-key-collection', {
        toggle,
        outputsSet,
        doorphones,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  uploadMassTextmessage (text, doorphones, { start_date: startDate, end_date: endDate } = {}) {
    return new Promise((resolve, reject) => {
      const payload = {
        text,
        doorphones,
      };
      if (startDate != null && startDate !== '') {
        payload.start_date = startDate;
      }
      if (endDate != null && endDate !== '') {
        payload.end_date = endDate;
      }
      axios.post('/doorphone/text', payload)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  massUpdateSoundSettings (doorphones, settings) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/sound', {
        doorphones,
        cOpenDoorWarning: settings.cOpenDoorWarning,
        cHandoffSendVolume: settings.cHandoffSendVolume,
        cSpeakerVolume: settings.cSpeakerVolume,
        cAECLevel: settings.cAECLevel,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  massAttachUniversalKey (doorphones, keys) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/mass-attach-universal-key', {
        doorphones,
        keys,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  getTextmessage (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/text`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getDoorsound (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/wav-open`, {
        responseType: 'blob',
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getRingsound (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/wav-ring`, {
        responseType: 'blob',
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  openDoor (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/open-door`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  openDoors (formData) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/open-door', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getFreeKeys (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/key/free-keys`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getAutoKeyCollection (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/auto-key-collection`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getFreeUniversalKeys (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/key/free-universal-keys`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  addKey (doorphone, key, duplicate) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphone}/key/${key}`, { duplicate })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  detachKey (doorphone, key, duplicate) {
    return new Promise((resolve, reject) => {
      axios.delete(`/doorphone/${doorphone}/key/${key}?duplicate=${duplicate}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  deleteKeysByCsv (doorphone, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphone}/key/destroy-by-csv`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  exportCsv () {
    return new Promise((resolve, reject) => {
      axios.get('/doorphone/export-csv', { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  changeDevice (doorphone, device) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphone}/device/${device}`)
        .then((response) => {
          if (response.data.errors.length > 0) {
            reject(response.data.errors);
          } else {
            resolve(response);
          }
        })
        .catch(error => reject(error));
    });
  },
  getRelay (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/relay`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  updateRelay (id, data) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/relay`, data)
        .then((response) => {
          resolve(response);
        })
        .catch(error => {
          if (error.data && error.data.error && error.data.errors.length > 0) {
            reject(error.data.errors);
          } else {
            reject(error);
          }
        });
    });
  },
  importRelay (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/relay/doorphone/${id}/import`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  analyticsInfo ({ id }) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/analytics-info`)
        .then((response) => {
          resolve(response.data.doorphone);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  changeAnalyticsParams ({ id, ...params }) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/analytics`, { ...params })
        .then(resolve)
        .catch(reject);
    });
  },
  changeAddress (id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/address`, data)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  rebootDoorphone (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/reboot`)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  massRebootDoorphone (doorphones) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/mass-reboot', { doorphones })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  exportSipHistoryCsv (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/sip-status-logs/export-csv`, { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getCallStart (doorphoneId, apartment, target) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphoneId}/call-start`, {
        apartment,
        target,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getCallEnd (doorphoneId) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphoneId}/call-end`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  callCheck (doorphoneId) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphoneId}/call-check`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateServiceDoorCode (id, serviceDoorCode, lifetimeDays, rotationLocked, rotationComment) {
    return new Promise((resolve, reject) => {
      const locked = !!rotationLocked;
      const payload = {
        service_door_code: serviceDoorCode,
        rotation_locked: locked,
      };
      if (lifetimeDays != null) {
        payload.lifetime_days = lifetimeDays;
      }
      if (locked) {
        payload.rotation_comment = String(rotationComment == null ? '' : rotationComment).trim();
      }
      axios.put(`/doorphone/${id}/service-door-code`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  getServiceCode (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/service-code`)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  updateServiceCode (id, pass) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/service-code`, {
        pass,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  updateScanByCode (id, scanByCode) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/scan-by-code`, {
        scan_by_code: scanByCode,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  getConciergeNumber (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/concierge-number`)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  updateConciergeNumber (id, conciergeNumber) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/concierge-number`, {
        concierge_number: conciergeNumber,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  updateApartmentsBeward (id, rules) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/apartments`, { rules })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  changeApartments (id) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/apartment-preset`)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  heatingView (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/heating`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  editHeating (id, cHeatThresHold, cHeatSwitch) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/heating`, {
        cHeatThresHold: cHeatThresHold,
        cHeatSwitch: cHeatSwitch,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  getSoundSettingsBeward (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/beward-sound`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  updateSoundSettingsBeward (id, settings) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/beward-sound`, settings)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getActions (id, options) {
    const params = {};

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/actions?` + query.join('&'))
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  audioUpload (options) {
    const params = {};

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.media_type) {
      params.media_type = options.media_type;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/audio-upload?' + query.join('&'))
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  detailInfoAudioUpload (massUploadId, options) {
    const params = {};

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.status === 0 || options.status === 1) {
      params.status = options.status;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }
    return new Promise((resolve, reject) => {
      axios.get(`/audio-upload/${massUploadId}?` + query.join('&'))
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  dwdrView (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/dwdr`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  viewLCDSettings (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/lcd-settings`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  editLCDSettings (id, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/lcd-settings`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  editDWDR (id, DWDR, DWDRLevel) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/dwdr`, {
        dwdr: DWDR,
        dwdr_level: DWDRLevel,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  sipStatistics (dateFrom, dateTo) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/sip-status-statistics?date_from=${dateFrom}&date_to=${dateTo}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getSipStatusLogs (dateFrom, dateTo) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/sip-status-logs?date_from=${dateFrom}&date_to=${dateTo}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  changeAgent (id, agentId) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/agent/${agentId}`)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  updateSnapshot (id) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/snapshot`)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  getTempCode (id, form) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/temp-code`, {
        telephone: form.telephone,
        apartment: form.apartment,
        fio: form.fio,
        reason: form.reason,
        type: form.type,
        hours: form.hours,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  installDoorOpeningTime (id, wait) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/discrete-logic/door-opening-time`, {
        wait: wait,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  activateDoorphone (doorphoneId, form) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphoneId}/activate`, {
        apartment: form.apartment,
        client_id: form.clientId,
        duplicate: form.duplicate,
        key_id: form.keyId,
        activation_duration_minutes: form.activation_duration_minutes,
        activation_duration_days: form.activation_duration_days,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  testActivateDoorphone (doorphoneId, form) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphoneId}/test-activate`, {
        phone: form.phone,
        apartment: form.apartment,
        activation_duration_days: form.activation_duration_days,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  lkActivateDoorphone (doorphoneId, form) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphoneId}/lk-activate`, {
        phone: form.phone,
        apartment: form.apartment,
        key_code: form.key_code,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  getTimeOpeningDoor (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/discrete-logic/door-opening-time`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getAnalogLineAnalysis (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/analog-line-analysis`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  updateAnalogLineAnalysis (id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/analog-line-analysis`, data)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  getAnalogLineApartmentSettings (id, apartment) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/analog-line-apartment-settings?apartment=${apartment}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  updateAnalogLineApartmentSettings (id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/analog-line-apartment-settings`, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(e => reject(e));
    });
  },
  getMeasurementAnalogLine (id, { number, numberTo }) {
    return new Promise((resolve, reject) => {
      let query = `number=${number}`;
      if (numberTo != null && numberTo !== '') {
        query += `&number_to=${numberTo}`;
      }
      axios.post(`/doorphone/${id}/analog-line-voltage/check?${query}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  stopMeasurementAnalogLine (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/analog-line-voltage/stop`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  updateNtpAddress ({ selectedTmp }) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/ntp-address', selectedTmp)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  updateMassLsdSettings (formData) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/mass-lcd-settings', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  openDoorSoundReset ({ doorphones }) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/open-door-sound/reset', {
        doorphones,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  massResetLcdImage ({ doorphones }) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/mass-lcd-settings/reset', {
        doorphones,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  getInfoDoorphoneEdit (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/web/doorphone/${id}/edit`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getCheckCameras () {
    return new Promise((resolve, reject) => {
      axios.get('/navy/check-cameras')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  getAudioMessage (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/audio-message`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  getCustomMode (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/custom-mode`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  updateAudioMessage (id, volume) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/audio-message?volume=${volume}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  setCustomMode (id, isEnabledMode) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/custom-mode?is_enabled_mode=${isEnabledMode}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  checkAnalogLineBeward (id, number) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/analog-line-beward-voltage?number=${number}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getAnalogLineBeward (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/analog-line`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  updateAnalogLineBeward (id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/analog-line`, data)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  showRuleSipSettings (idDoorphone) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${idDoorphone}/rules-sip-settings`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getCodeApartment (id, number) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/code-apartment`, {
        params: { apartment: number },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  setCodeApartment (id, number) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/code-apartment`, {
        apartment: number,
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  updateCodesFromDoorphone (id) {
    return axios.post(`/doorphone/${id}/sync-codes`).then(res => res.data);
  },
  syncMainDoorphoneCodes (id) {
    return axios.post(`/doorphone/${id}/sync-main-doorphone-codes`).then(res => res.data);
  },
  massSipStatus (payload) {
    return new Promise((resolve, reject) => {
      axios.post('/doorphone/mass-sip-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getSipCacheStatistics (params) {
    return new Promise((resolve, reject) => {
      axios.get('/doorphone/sip-cache-statistics', {
        params: params,
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch(error => reject(error));
    });
  },
  getTempCodeProvisionHistory (id, options = {}) {
    const qs = buildTempCodeProvisionHistoryQuery(options);
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/temp-code-provision-history${qs}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getTempCodeProvisionHistoryAll (options = {}) {
    const qs = buildTempCodeProvisionHistoryQuery(options);
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/temp-code-provision-history${qs}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getServiceDoorCodeHistory (id, options = {}) {
    const qs = buildTempCodeProvisionHistoryQuery(options);
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/service-door-code-history${qs}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getServiceDoorCodeHistoryAll (options = {}) {
    const qs = buildTempCodeProvisionHistoryQuery(options);
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/service-door-code-history${qs}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getApartmentSipPasswordRequestsHistory (options = {}) {
    const params = {};
    if (options.page) {
      params.page = options.page;
    }
    if (options.limit) {
      params.limit = options.limit;
    }
    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }
    const qs = query.length ? '?' + query.join('&') : '';
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/apartment-sip-password-requests-history${qs}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
};
